<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <paginated-table
          v-else
          :data="members"
          :columns="tableColumns"
          :title="$t('title.admin_list')"
          @updatePagination="updatePagination"
        />
        <info-modal
          :data="currentMember"
          :isVisible="showDetailInfo"
          @close="showDetailInfo = false"
        ></info-modal>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PaginatedTable from "@/components/Tables/PaginatedTable.vue";
import InfoModal from "@/components/cards/InfoModal.vue";
import LoadingSpinner from "@/components/common/Spinners/LoadingSpinner.vue";

import {
  addAdminRole,
  deleteAdminRole,
  success,
} from "@/views/MemberView/popups";
import { getAdminColumns } from "@/views/MemberView/columns";
import { memberApi } from "@/api/api.js";

export default {
  components: {
    PaginatedTable,
    InfoModal,
    LoadingSpinner,
  },
  data() {
    return {
      members: {
        page_info: {
          page: 1,
          size: 5,
          total_elements: 5,
          total_pages: 1,
        },
        elements: [],
      },
      isLoading: false,
      showDetailInfo: false,
      currentMember: {},
      tableColumns: getAdminColumns({
        showDetail: this.showDetail,
        addRole: this.handleAddAdminRole,
        deleteRole: this.handleDeleteAdminRole,
      }),
    };
  },

  methods: {
    async handleAddAdminRole(member) {
      const selectedValue = await addAdminRole(member);

      if (!selectedValue) {
        return;
      }

      const params = {
        member_idx: member.idx,
      };

      const body = {
        role: selectedValue,
      };

      const isAdded = await this.addAdminRole(body, params);

      if (isAdded) {
        await success();
        await this.getAdmins(
          this.members.page_info.size,
          this.members.page_info.page
        );
      }
    },
    async handleDeleteAdminRole(member) {
      const selectedValue = await deleteAdminRole(member);

      if (!selectedValue) {
        return;
      }

      const params = {
        member_idx: member.idx,
      };

      const isDeleted = await this.deleteAdminRole(params);

      if (isDeleted) {
        await success();
        await this.getAdmins(
          this.members.page_info.size,
          this.members.page_info.page
        );
      }
    },
    /**
     * 회원 정보 상세 조회 메서드
     */
    showDetail(item) {
      this.currentMember = {
        title: {
          label: this.$t("label.member_name"),
          value: item.name,
        },
        email: {
          label: this.$t("label.member_email"),
          value: item.email,
        },
        organization: {
          label: this.$t("label.member_organization"),
          value: item.organization,
        },
        department: {
          label: this.$t("label.member_department"),
          value: item.department,
        },
        position: {
          label: this.$t("label.member_position"),
          value: item.position,
        },
      };

      this.showDetailInfo = !this.showDetailInfo;
    },

    /**
     * 회원 전체 조회 API 요청
     *
     * @description: 회원 목록 전체 조회 메서드
     * @param {number} size - 사이즈
     * @param {number} page - 페이지
     */
    async getAdmins(size, page) {
      this.isLoading = true;
      const params = {
        size: size,
        page: page,
      };

      const response = await memberApi.getAdmins(params);
      if (response && response.status === 200) {
        this.members = response.data.response;
        this.isLoading = false;
      } else {
        this.notifyVue({
          message: this.$t("alert.failed_request"),
          style: "danger",
        });
        this.isLoading = false;
      }
    },

    async addAdminRole(data, params) {
      const response = await memberApi.addAdminRole(data, params);

      if (response && response.status === 201) {
        return true;
      } else {
        this.notifyVue({
          message: this.$t("alert.failed_request"),
          style: "danger",
        });
        return false;
      }
    },
    async deleteAdminRole(params) {
      const response = await memberApi.deleteAdminRole(params);

      if (response && response.status === 204) {
        return true;
      } else {
        this.notifyVue({
          message: this.$t("alert.failed_request"),
          style: "danger",
        });
        return false;
      }
    },

    /**
     * Pagination 타입 명세
     * @typedef {Object} Conditions
     * @property {string} page - 페이지
     * @property {string} size - 사이즈
     * @property {string} total_elements - 전체 데이터 수
     * @property {string} total_pages - 전체 페이지 수
     */

    /**
     * 페이지네이션 업데이트 메서드
     *
     * @description: 페이징 정보가 변경되면 하위 컴포넌트에서 정보를 받아 업데이트 및 API 요청
     * @params {Pagination} pagination
     */
    updatePagination(pagination) {
      this.members.page_info.size = pagination.size;
      this.members.page_info.page = pagination.page;

      this.getAdmins(this.members.page_info.size, this.members.page_info.page);
    },

    /* ****************************************************************************************
     * 알럿
     * ****************************************************************************************/
    notifyVue({
      vertical = "top",
      horizontal = "right",
      message = "",
      style = "primary",
      icon = "priority_high",
    } = {}) {
      this.$notify({
        timeout: 8000,
        message: message,
        icon: icon,
        type: style,
        horizontalAlign: horizontal,
        verticalAlign: vertical,
      });
    },
  },
  mounted() {
    this.getAdmins(this.members.page_info.size, this.members.page_info.page);
  },
};
</script>

<style scoped></style>
